<template>
  <div>
    <el-drawer
      :visible.sync="changVisible"
      :title="title"
      width="30%"
      :before-close="$onClose"
      destroy-on-close
    >
      <div>
        <el-button
          @click="onBack"
          type="primary"
          size="small"
          class="btn_back"
          v-if="is_restore"
          >还原</el-button
        >
        <el-button v-else type="button" size="small" class="btn_back" disabled
          >已还原</el-button
        >

        <!-- <el-button type="primary" size="mini" plain class="btn_back" @click="onBack">还原</el-button> -->
      </div>

      <el-table :data="tableData" class="this_table">
        <el-table-column
          prop="index"
          label="序号"
          min-width="1"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="name_cn"
          label="校友名称"
          min-width="2"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="resultS"
          label="执行结果"
          min-width="5"
          align="left"
        ></el-table-column>
      </el-table>

      <el-pagination
        class="elPagination"
        background
        layout="prev, pager, next"
        :page-size="pageMaxSize"
        :page-count="pageCount"
        @current-change="currentChange"
        v-if="resetElPagination"
      ></el-pagination>
    </el-drawer>
  </div>
</template>

<script>
import { URL_PATH, LIST_PAGE_MAX_SIZE } from '@/config/config'

export default {
  data() {
    return {
      changVisible: false,
      is_restore: false,
      resetElPagination: true,
      title: "通过Excel导入信息",
      recordLogId: "",
      tableData: [],
      dataListPageIndex: 1,
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      pageCount: 0,
      tableIndex: 0,
    };
  },
  methods: {
    $onClose(done) {
      this.tableData = [];
      this.dataListPageIndex = 1;
      done();
    },
    //页面初始化时加载的事件
    show(row, index) {
      this.is_restore = row.is_restore == 0;
      this.title = row.record_content;
      this.recordLogId = row.id;
      this.tableIndex = index;
      this.changVisible = true;
      this.getRecordLogLists();
    },
    // 获取操作日志列表
    getRecordLogLists() {
      this.$api
        .getRecordLogLists({
          token: localStorage.getItem("token"),
          recordLogId: this.recordLogId,
          page: this.dataListPageIndex,
          limit: this.pageMaxSize,
        })
        .then(({ data }) => {
          console.log(data);
          if (data.Code == 0) {
            this.tableData = data.Data.model;
            this.pageCount = data.Data.pageCount;
            var index = 1;
            this.tableData.forEach((element) => {
              element.index =
                index++ + this.pageMaxSize * (this.dataListPageIndex - 1);
            });
          }
        })
        .catch(({ error }) => {
          console.log(error);
        });
    },
    // 还原
    onBack() {
      this.changVisible = false;
      this.$emit("toBackOff", this.tableIndex);
    },
    // 翻页
    currentChange(val) {
      this.dataListPageIndex = val;
      this.getRecordLogLists();
    },
  },
};
</script>
<style lang="less" scoped>
.this_table {
  width: 90%;
  margin: 0 auto;
}
.btn_back {
  float: right;
  margin-right: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/drawer/opLogDrawer.vue